import React, { useEffect, useState, useContext } from 'react';
import db from '../firebase';
import './Plants.css';
import { CartContext } from '../context/CartContext';
import {
  collection,
  query,
  orderBy,
  limit,
  getDocs,
  startAfter,
} from 'firebase/firestore';

function Plants() {
  const [plants, setPlants] = useState([]);
  const [lastVisible, setLastVisible] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageStack, setPageStack] = useState([]);
  const [addedIndex, setAddedIndex] = useState(null);

  const plantsPerPage = 16;
  const { addToCart, toggleCart, cartItems } = useContext(CartContext);

  useEffect(() => {
    loadInitialPage();
  }, []);

  const loadInitialPage = async () => {
    const q = query(collection(db, 'plants'), orderBy('code'), limit(plantsPerPage));
    const snapshot = await getDocs(q);
    const docs = snapshot.docs.map((doc) => doc.data());
    setPlants(docs);
    setLastVisible(snapshot.docs[snapshot.docs.length - 1]);
    setPageStack([snapshot.docs[0]]);
    setCurrentPage(1);
  };

  const loadNextPage = async () => {
    const q = query(
      collection(db, 'plants'),
      orderBy('code'),
      startAfter(lastVisible),
      limit(plantsPerPage)
    );
    const snapshot = await getDocs(q);
    if (!snapshot.empty) {
      const docs = snapshot.docs.map((doc) => doc.data());
      setPlants(docs);
      setLastVisible(snapshot.docs[snapshot.docs.length - 1]);
      setPageStack((prev) => [...prev, snapshot.docs[0]]);
      setCurrentPage((prev) => prev + 1);
    }
  };

  const loadPrevPage = async () => {
    const newStack = [...pageStack];
    newStack.pop();
    const prevCursor = newStack[newStack.length - 1];

    const q = query(
      collection(db, 'plants'),
      orderBy('code'),
      startAfter(prevCursor),
      limit(plantsPerPage)
    );
    const snapshot = await getDocs(q);
    const docs = snapshot.docs.map((doc) => doc.data());
    setPlants(docs);
    setLastVisible(snapshot.docs[snapshot.docs.length - 1]);
    setPageStack(newStack);
    setCurrentPage((prev) => prev - 1);
  };

  const handleQuantityChange = (index, delta) => {
    setPlants((prev) =>
      prev.map((plant, i) =>
        i === index
          ? { ...plant, quantity: Math.max(1, (plant.quantity || 1) + delta) }
          : plant
      )
    );
  };

  const handleSizeChange = (index, size) => {
    setPlants((prev) =>
      prev.map((plant, i) => (i === index ? { ...plant, size } : plant))
    );
  };

  const handleAddToCart = (plant, index) => {
    if (!plant.size) {
      alert('Please select a size before adding to cart.');
      return;
    }
    addToCart({
      name: plant.name,
      size: plant.size,
      quantity: plant.quantity || 1,
      image: plant.image,
      category: plant.category,
    });

    setAddedIndex(index);
    setTimeout(() => setAddedIndex(null), 500);
  };

  return (
    <div className="plants-page">
      <h2>Our Native Plants</h2>

      <div className="plants-grid">
        {plants.map((plant, index) => {
          const inCart = !!cartItems.find(
            (item) => item.name === plant.name && item.size === plant.size
          );

          return (
            <div className="plant-card" key={index}>
              <img src={plant.image} alt={plant.name} />
              <h3>{plant.name}</h3>
              <p className="plant-category">{plant.category}</p>

              <div className="size-quantity-row">
                <div className="quantity-selector">
                  <button onClick={() => handleQuantityChange(index, -1)}>-</button>
                  <input
                    type="number"
                    className="product-quantity"
                    name="quantity"
                    value={plant.quantity || 1}
                    readOnly
                  />
                  <button onClick={() => handleQuantityChange(index, 1)}>+</button>
                </div>

                <select
                  name="size"
                  className="product-size"
                  value={plant.size || ''}
                  onChange={(e) => handleSizeChange(index, e.target.value)}
                >
                  <option value="">Select Size</option>
                  <option value="Plugs">Plugs</option>
                  <option value="10cm">10cm</option>
                  <option value="1-gallon">1-gallon</option>
                  <option value="2-gallon">2-gallon</option>
                  <option value="3-gallon">3-gallon</option>
                  <option value="5-gallon">5-gallon</option>
                  <option value="10-gallon">10-gallon</option>
                </select>
              </div>

              {addedIndex === index ? (
                <button className="add-to-cart added" disabled>Added to Cart</button>
              ) : (
                <button className="add-to-cart" onClick={() => handleAddToCart(plant, index)}>
                  Add to Cart
                </button>
              )}

              {inCart && plant.size && (
                <button className="view-cart-btn" onClick={toggleCart}>
                  View Cart
                </button>
              )}
            </div>
          );
        })}
      </div>

      <div className="pagination">
        <button onClick={loadPrevPage} disabled={currentPage === 1}>
          &lt; Prev
        </button>
        <span>Page {currentPage}</span>
        <button onClick={loadNextPage}>Next &gt;</button>
      </div>
    </div>
  );
}

export default Plants;
